import Content from "./Content";
const Container = ({ children }) => {
  return (
    <main className="py-10">
      <div className="relative px-4 sm:px-6 lg:px-8">
        <Content>{children}</Content>
      </div>
    </main>
  );
};

export default Container;
